// extracted by mini-css-extract-plugin
export default {"wrapper":"ZDyK9Una1JPvx_2dUQUn","breadcrumb":"eiIpvrHTPwYkJ5nmAj4n","title":"S0sofKlqQJ8Js7uALJSe"};